<template>
    <v-container>

        <v-row>
            <v-col class="d-flex justify-end">
                <v-btn class="btn_style3" dark  @click="volver">VOLVER</v-btn>
            </v-col>
        </v-row>

        
        <v-row>

                <v-col cols="6" class="grey lighten-3">
                    <v-alert dense outlined type="info">
                        <strong>DIAPOSITIVAS DE SECCIONES</strong>
                    </v-alert>


                    <v-row class="d-flex justify-space-around mb-6">
                        <v-col cols="12" lg="3" md="4" sm="6" class="card-hover">
                             

                                <v-card @click="selectPlantilla('ColC1')">
                                    <v-img src="@/assets/iconos/1Columna.svg" class="white--text align-end"></v-img>
                                </v-card>
              
                        </v-col>


                        <v-col cols="12" lg="3" md="4" sm="6"  class="card-hover">
                           
                                <v-card @click="selectPlantilla('ColC2')">
                                    <v-img src="@/assets/iconos/2Columnas.svg" class="white--text align-end"></v-img>
                                </v-card>
         
                        </v-col>


                        <v-col cols="12" lg="3" md="4" sm="6" class="card-hover">
         
                                <v-card @click="selectPlantilla('ColC3')">
                                    <v-img src="@/assets/iconos/3Columnas.svg" class="white--text align-end"></v-img>
                                </v-card>
                          
                        </v-col>
                    </v-row>
                </v-col>
                
                
                
                <v-col cols="6"  class="blue lighten-5">
                    <v-alert dense outlined type="info">
                        <strong>DIAPOSITIVAS DE PREGUNTAS</strong>
                    </v-alert>

                    <v-row class="d-flex justify-space-around mb-6">
                        <v-col cols="12" lg="3" md="4" sm="6" class="card-hover">
                            <v-card @click="selectPlantilla('pregPU')">
                                <v-img  src="@/assets/iconos/Respuesta_unica.svg" class="white--text align-end"></v-img>
                            </v-card>
                        </v-col>
            
                        <v-col cols="12" lg="3" md="4" sm="6" class="card-hover">
                            <v-card @click="selectPlantilla('pregPM')">
                                <v-img src="@/assets/iconos/Respuesta_multiple.svg" class="white--text align-end"></v-img>
                            </v-card>
                        </v-col>

                        <v-col cols="12" lg="3" md="4" sm="6" class="card-hover">
                            <v-card @click="selectPlantilla('pregPV')">
                                <v-img src="@/assets/iconos/Verdadero_o_falso.svg" class="white--text align-end"></v-img>
                            </v-card>
                        </v-col>
                          
                    </v-row>
             </v-col>
            </v-row>
    </v-container>
</template>


<script>
    export default {
        name:'selectorDiapositiva',
        data(){
            return{  }
        },
        
        methods:{
            selectPlantilla(col){
                this.$emit('cargarPlantilla',col);
            },

            volver(){
                this.$emit('irAtras');
            }
        }
    }
</script>

<style  scoped>
    .card-hover:hover{
        background: rgb(236, 195, 9);
        
        /*
        border: solid 4px rgb(236, 195, 9);
        */
    }
</style>